import React from 'react';

export default function Modal({
  display = true, closeX = true,
  closeOnBlur = true, close,
  width = '60%', height = '90%',
  children = null,
}) {
  if (!display) return null;

  return (
    <div className="modal" onClick={closeOnBlur ? close : null}>
      <div
        className="modal-body"
        onClick={evt => evt.stopPropagation()}
        style={{ width, height }}
      >
        {
          closeX
            ? <span className="img modal-x add-hover" onClick={close} />
            : null
        }
        {children}
      </div>
    </div>
  );
}
